import React from "react";
import "./modal.scss";

export const handleCheckboxKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
  if (e.key === "Enter" && (e.target as HTMLElement).tagName === "INPUT") {
    const inputElement = e.target as HTMLInputElement;
    if (inputElement.type === "checkbox") {
      e.preventDefault();
      inputElement.click();
    }
  }
};

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="modal-close-button" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
